import { patch } from "./base";

//actualizacion de estatus planes de cuidado
export const actualizarPlanCuidadoEstatus = async (data) => {
  try {
    const request = { estatus: data.codigoEstatus };
    const response = await patch(`/PlanesCuidado?id=${data.id}`, request);
    return response.data;
  } catch (error) {
    throw new Error("Error actualizando plan de cuidado: " + error.message);
  }
};
